// App.js - Main Application Component
import React, { useState, createContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import AuthorList from './components/AuthorList';
import CategoryList from './components/CategoryList';
import BookList from './components/BookList';
import AudioPlayer from './components/AudioPlayer';
import AllBooks from './components/AllBooks';
import './App.css';
// Create search context to share search state across components
export const SearchContext = createContext();

// Create a separate component to reset search on navigation
function SearchResetHandler({ children }) {
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  
  // Reset searchTerm when location changes
  useEffect(() => {
    setSearchTerm('');
  }, [location.pathname]);
  
  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
      {children}
    </SearchContext.Provider>
  );
}

function AppContent() {
  return (
    <div className="app-container">
      <header className="app-header">
        <h1>აუდიო წიგნების ბიბლიოთეკა</h1>
        <nav className="main-nav">
          <Link to="/">მთავარი</Link>
          <Link to="/authors">ავტორები</Link>
          <Link to="/books">წიგნები</Link>
        </nav>
      </header>
      
      <main className="app-main">
        <Routes>
          <Route path="/" element={<AuthorList />} />
          <Route path="/authors" element={<AuthorList />} />
          <Route path="/books" element={<AllBooks />} />
          <Route path="/author/:authorId" element={<CategoryList />} />
          <Route path="/category/:categoryId" element={<BookList />} />
          <Route path="/book/:bookId" element={<AudioPlayer />} />
        </Routes>
      </main>
      
      <footer className="app-footer">
        <p>&copy; {new Date().getFullYear()} AudioBook Library</p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router basename="/">       
      <SearchResetHandler>
        <AppContent />
      </SearchResetHandler>
    </Router>
  );
}

export default App;